import React, { useState } from "react";
import AuthLayout from "components/Layout/AuthLayout";
import { AuthCard } from "components/Card/AuthCard";
import { lang } from "constant/lang";
import { useForm } from "react-hook-form";
import actionApi from "services/actionApi";
import makeToast from "utils/toast/makeToast";
import Button from "components/Button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import InputPassword from "components/Form/InputPassword";
import { useQuery } from "hooks/useQuery";

const ResetPasswordPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { getQuery } = useQuery();
  const {
    register,
    watch,
    formState: { errors, isDirty, isValid },
    handleSubmit,
    setError,
  } = useForm();
  const disabled =
    isSubmitting || !isDirty || !isValid || Object.keys(errors).length > 0;

  const onSubmit = async (payload) => {
    if (payload?.password !== payload?.repassword) {
      setError("repassword", {
        type: "custom",
        message: "Password doesn’t match.",
      });
      return;
    }

    const query = getQuery(location.search);
    setIsSubmitting(true);
    actionApi
      .resetPassword({ token: query?.token, new_password: payload?.password })
      .then((response) => {
        navigate("/login");
      })
      .catch((err) => {
        makeToast({ label: err?.response?.data?.errors?.[0], type: "error" });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <AuthLayout>
      <AuthCard className="justify-center">
        <span className="text-2xl text-wce-navy font-medium mb-6 self-center">
          Change Password
        </span>
        <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
          <InputPassword
            {...register("password", { required: true })}
            className="mb-4"
            placeholder="Enter New Password"
            errors={errors}
          />
          <InputPassword
            {...register("repassword", { required: true })}
            className="mb-4"
            placeholder="Re-enter New Password"
            errors={errors}
          />
          <Button
            type="submit"
            size="large"
            className="w-full mb-6 h-10"
            rounded
            disabled={disabled}
          >
            Change Password
          </Button>
        </form>
      </AuthCard>
    </AuthLayout>
  );
};

export default ResetPasswordPage;
